import React, { useEffect } from "react";
import HeroBanner from "../../components/DynamicHero";
import PageLayout from "../../components/PageLayout";
import { eshopPageData } from "../../data/data";
import { setMetaTag, setPropertyMetaTag } from "../../helpers/seoUtils";
import { useTranslation } from "react-i18next";

const EshopPage = () => {
  const { t } = useTranslation("eshop");
  useEffect(() => {
    document.title = "E-shop for Playground Equipment – Economus";

    setMetaTag(
      "description",
      "Browse high-quality playground equipment in our Economus e-shop. Safe, certified, and perfect for schools, parks, and more."
    );
    setMetaTag(
      "keywords",
      "playground equipment, e-shop, Economus, playgrounds in Lithuania, žaidimų aikštelės įranga"
    );
    setMetaTag("robots", "index, follow");
    setMetaTag("twitter:card", "summary_large_image");
    setMetaTag("twitter:title", "E-shop for Playground Equipment – Economus");
    setMetaTag(
      "twitter:description",
      "Explore top-quality and certified playground equipment available for purchase in Lithuania."
    );
    setMetaTag(
      "twitter:image",
      "https://economus.netlify.app/static/media/pendulum.20e909409cfce0e283da.png"
    );
    setMetaTag("language", "lt");
    setMetaTag("geo.region", "LT");
    setMetaTag("geo.placename", "Lithuania");

    setPropertyMetaTag(
      "og:title",
      "E-shop for Playground Equipment – Economus"
    );
    setPropertyMetaTag(
      "og:description",
      "Your destination for safe and certified playground equipment across Lithuania."
    );
    setPropertyMetaTag(
      "og:image",
      "https://economus.netlify.app/static/media/pendulum.20e909409cfce0e283da.png"
    );
    setPropertyMetaTag("og:url", "https://economus.netlify.app/e-shop");
    setPropertyMetaTag("og:type", "website");
  }, []);

  return (
    <>
      <HeroBanner text={t("equipmentTitle")} />
      <PageLayout
        heading={t(eshopPageData.heading)}
        desc={t(eshopPageData.description)}
        cardData={eshopPageData.sections.map((card) => ({
          ...card,
          title: t(card.title),
          desc: t(card.desc!),
          path: card.path,
        }))}
      />
    </>
  );
};

export default EshopPage;
